module.exports = __webpack_public_path__ + "static/media/dark-theme-stop-duration.c5ea7dff.svg";